import styled from '@emotion/styled';
import { getTheme } from 'settings/theme/index';

const {
  noodera: { fontTypes },
  palette: { primary },
  underlineLink,
} = getTheme();

export const EditProfileTitle = styled.h2`
  ${fontTypes.font4Medium}
  font-weight: 600;
  color: black;
`;

export const EditProfileLink = styled.span`
  ${fontTypes.font5Medium}
  ${underlineLink}
  width: max-content;
  font-weight: 700;
  color: ${primary.hundred};
`;
